import { memo, useState } from "react";
import Accordion from "../../../components/accordian";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import TextInput from "../../../components/inputs/TextInput";

interface EmployeeInformationProps {
  control: any;
  errors: any;

  employeeDetails?: {
    name: string;
    department: string;
    jobTitle: string;
    mobileNo: string;
    employeeNumber: string;
  };

  isFieldsDisabled: boolean;
}

const EmployeeInformation = ({
  control,
  errors,
  employeeDetails,
  isFieldsDisabled,
}: EmployeeInformationProps) => {
  const { t, } = useTranslation();

  const [selectedKey, setSelectedKey] = useState<string>("1");

  return (
    <div className="bg-white z-10 p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
      <Accordion
        id="1"
        selectedKey={selectedKey}
        onSelectionChange={setSelectedKey}
        title={
          <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
            {t("2")}. {t("employeeInformation")}
          </h1>
        }
      >
        <div className="flex flex-col gap-2 lg:gap-4">
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 lg:gap-4">
            <Controller
              name="name"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("name")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled || !!employeeDetails?.name}
                />
              )}
            />

            <Controller
              name="department"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("department")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled || !!employeeDetails?.department}
                />
              )}
            />


            <Controller
              name="jobTitle"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("jobTitle")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled || !!employeeDetails?.jobTitle}
                />
              )}
            />

            <Controller
              name="mobileNo"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("mobileNumber")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled || !!employeeDetails?.mobileNo}
                />
              )}
            />

            <Controller
              name="officePhoneNo"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("officePhoneNumber")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled}
                />
              )}
            />

            <Controller
              name="employeeNumber"
              control={control}
              render={({ field: { onChange, name, value } }) => (
                <TextInput
                  label={t("employeeNumber")}
                  value={value}
                  onChange={onChange}
                  error={errors?.[name]?.message}
                  required
                  readOnly={isFieldsDisabled || !!employeeDetails?.employeeNumber}
                />
              )}
            />

          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default memo(EmployeeInformation);
